import api from './client';
import type {
  PartnerCredential, CredentialSecret, CredentialRevealPending, CredentialTotpCode,
  CreateCredentialInput, UpdateCredentialInput,
} from './types';

export async function getCredentials(): Promise<PartnerCredential[]> {
  return api.get<PartnerCredential[]>('/admin/credentials');
}

export async function createCredential(data: CreateCredentialInput): Promise<{ id: string }> {
  return api.post<{ id: string }>('/admin/credentials', data);
}

export async function updateCredential(id: string, data: UpdateCredentialInput): Promise<{ id: string }> {
  return api.patch<{ id: string }>(`/admin/credentials/${id}`, data);
}

export async function deleteCredential(id: string): Promise<{ message: string }> {
  return api.delete<{ message: string }>(`/admin/credentials/${id}`);
}

/**
 * Answers either with the secret or — for anyone but a super admin without a
 * live approval — with a filed request. Both arrive as 2xx, so the caller has
 * to look at `pending_approval` rather than at the HTTP status.
 */
export async function revealCredential(
  id: string,
): Promise<CredentialSecret | CredentialRevealPending> {
  return api.post<CredentialSecret | CredentialRevealPending>(
    `/admin/credentials/${id}/reveal`, {},
  );
}

/** Same two-answer contract as revealCredential, on its own approval. */
export async function getCredentialTotp(
  id: string,
): Promise<CredentialTotpCode | CredentialRevealPending> {
  return api.post<CredentialTotpCode | CredentialRevealPending>(
    `/admin/credentials/${id}/totp`, {},
  );
}

export { isRevealPending } from './reveal';
